export const actions = {
    GET_DAILY_VISITORS: 'GET_DAILY_VISITORS',
    SET_DAILY_VISITORS: 'SET_DAILY_VISITORS',

    GET_STUDENT_VISITORS: 'GET_STUDENT_VISITORS',
    SET_STUDENT_VISITORS: 'SET_STUDENT_VISITORS',

    GET_TOTAL_VISITORS: 'GET_TOTAL_VISITORS',
    SET_TOTAL_VISITORS: 'SET_TOTAL_VISITORS',

    GET_ACTIVE_STUDENTS: 'GET_ACTIVE_STUDENTS',
    SET_ACTIVE_STUDENTS: 'SET_ACTIVE_STUDENTS',

    GET_VIRTUAL_CLASS_VIEW_STATS: 'GET_VIRTUAL_CLASS_VIEW_STATS',
    SET_VIRTUAL_CLASS_VIEW_STATS: 'SET_VIRTUAL_CLASS_VIEW_STATS',

    GET_FREQUENTLY_VISITED_COURSES: 'GET_FREQUENTLY_VISITED_COURSES',
    SET_FREQUENTLY_VISITED_COURSES: 'SET_FREQUENTLY_VISITED_COURSES',
    
    GET_REDIRECT_TO_ALMS_ACTIVITY_AND_EXAM_REPORT_URL: 'GET_REDIRECT_TO_ALMS_ACTIVITY_AND_EXAM_REPORT_URL'
};